import {CbarEntitySelect} from "./CbarEntitySelect.js";

window.customElements.define('cbar-entity-select', CbarEntitySelect);
